import axios from '../../apis/Api.js'

 export const SendOtpToUserThroughEmail = (requestData) => async () => {
   return await axios.post(`api/Authenticate/SendOtpToUserThroughEmail`, requestData);
 }

 
 export const VerifyOtpToUserThroughEmail = (requestData) => async () => {
   return await axios.post(`api/Authenticate/VerifyOtpToUserThroughEmail`, requestData);
 }

 
 export const UpdateUserPassword = (requestData) => async () => {
   return await axios.post(`api/Authenticate/UpdateUserPassword`, requestData);
 }

